import { Component } from 'react'
import PropTypes from 'prop-types'

class VersionManager extends Component {
    constructor(props) {
        super(props)

        // Expose the commands to dev console
        window.setClientVersion = this.setClientVersion
        window.setVersion = this.setLauncherVersion
    }

    shouldComponentUpdate() {
        return false
    }

    // Update the EVE client version
    setClientVersion = (serverId, version) => {
        try {
            this.props.setEveClientVersion(serverId, version)
        } catch (error) {
            console.info(`Encountered error while running setClientVersion: ${error.message}`)
        }
    }

    // Update the launcher version
    setLauncherVersion = (version) => {
        try {
            this.props.setLauncherBackendVersion(version)
        } catch (error) {
            console.info(`Encountered error while running setLauncherVersion: ${error.message}`)
        }
    }

    render() {
        return null
    }
}

VersionManager.propTypes = {
    setEveClientVersion: PropTypes.func,
    setLauncherBackendVersion: PropTypes.func,
}

export default VersionManager



// WEBPACK FOOTER //
// ./src/features/Backend/components/Backend/components/VersionManager/component.js